import React, { useEffect } from 'react'
import { PiArrowFatLinesLeftFill, PiArrowFatLinesRightFill } from "react-icons/pi";
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../hooks/appHooks';
import vendorProfile from '../../img/vendor_profile.png'
import { useTranslation } from 'react-i18next';
import useAxiosFetchApi from '../../hooks/useFetch';
import AppLoading from '../../utils/AppLoading';
import { HiCurrencyDollar, HiMiniShoppingCart } from 'react-icons/hi2';
import { FaBoxOpen } from "react-icons/fa";
import RecentOrdersTable from '../admin/RecentOrdersTable';
import FrequentProductsTable from './FrequentProductsTable';
import { ToastContainer } from 'react-toastify';
import { imgURL } from '../../apis/axios';
import { Box, DollarCircle, Shop, ShoppingCart } from 'iconsax-reactjs';
import VendorRecentOrdersTable from './VendorRecentOrdersTable';

const HOME_DETAILS_URL = "/details/vendor/home/{id}";

const VendorHome = () => {
  const { auth } = useAuth();
  const homeDetailsUrl = HOME_DETAILS_URL.replace("{id}", `${auth?.vendor?.vendor_id}`);
  const [state, setUrl] = useAxiosFetchApi(null, {}, auth?.token);
  const details = state.data?.data?.details;
  const { t, i18n } = useTranslation();

  const tCard = t("vendorCard")
  const tHome = t("vendorHomeInfo")

  useEffect(() => {
    setUrl(homeDetailsUrl)
  }, [auth?.vendor?.vendorId, homeDetailsUrl, setUrl])

  const homeVendor = auth?.vendor;

  return (
    <div className='flex flex-col mb-6'>
      <ToastContainer />
      <div className='flex justify-between items-center my-4'>
        <div className='flex justify-center items-center'>
          <div className="rounded-full">
            {
              homeVendor?.identity_image ?
                <img src={`${imgURL}/${homeVendor?.identity_image}`} alt="vendor" className='rounded-full' width={100} /> : <div className='flex items-center justify-center border-2 border-dashed w-[100px] h-[100px] rounded-full'>
                  <Shop size="60" className='text-slate-400' variant="Bulk" />
                </div>
            }
          </div>
          <div>
            <h2 className='font-medium mx-3'>{homeVendor?.full_name}</h2>
            <span className='px-3 ms-2 text-gray-500 text-sm'>
              {`${tCard['openingTxt']} ${homeVendor?.opening_time} - ${tCard['closingTxt']} ${homeVendor?.closing_time}`}
            </span>
          </div>
          <span className='px-3 ms-2 rounded-lg bg-gray-600 text-white text-sm'>{homeVendor?.vendor_type}</span>
        </div>
        <p className={`px-2 ${homeVendor?.is_working ? "bg-green-400" : "bg-red-500"} text-white rounded-lg p-1 text-[14px] inline-block`}>
          {homeVendor?.is_working ? tCard["working"] : tCard["outOfService"]}
        </p>
      </div>
      <hr />
      <div className='flex justify-between items-center text-center my-6'>
        <NavLink to={"/categories"} className='min-h-[150px] flex flex-col items-center justify-center border-0 bg-primary-color rounded-xl shadow-lg py-2 px-5 text-white'>
          <h2 className='text-2xl font-medium'>1</h2> {tHome["addCatTxt"]}</NavLink>
        {i18n.language === "en"
          ? <PiArrowFatLinesRightFill className='text-slate-300/60' size={40} style={{ display: "inline-block" }} />
          : <PiArrowFatLinesLeftFill className='text-slate-300/60' size={40} style={{ display: "inline-block" }} />}
        <NavLink to={"/product-info"} className='min-h-[150px] flex flex-col items-center justify-center border-0 bg-primary-color rounded-xl shadow-lg py-2 px-5 text-white'>
          <h2 className='text-2xl font-medium'>2</h2> {tHome["addProdTxt"]}</NavLink>
        {i18n.language === "en"
          ? <PiArrowFatLinesRightFill className='text-slate-300/60' size={40} style={{ display: "inline-block" }} />
          : <PiArrowFatLinesLeftFill className='text-slate-300/60' size={40} style={{ display: "inline-block" }} />}
        <NavLink to={"/products"} className='min-h-[150px] flex flex-col items-center justify-center border-0 bg-primary-color rounded-xl shadow-lg py-2 px-5 text-white'>
          <h2 className='text-2xl font-medium'>3</h2> {tHome["addCharTxt"]}</NavLink>
        {i18n.language === "en"
          ? <PiArrowFatLinesRightFill className='text-slate-300/60' size={40} style={{ display: "inline-block" }} />
          : <PiArrowFatLinesLeftFill className='text-slate-300/60' size={40} style={{ display: "inline-block" }} />}
        <NavLink to={"/orders"} className='min-h-[150px] flex flex-col items-center justify-center border-0 bg-primary-color rounded-xl shadow-lg py-2 px-5 text-white'>
          <h2 className='text-2xl font-medium'>4</h2> {tHome["recieveCustTxt"]}</NavLink>
        {i18n.language === "en"
          ? <PiArrowFatLinesRightFill className='text-slate-300/60' size={40} style={{ display: "inline-block" }} />
          : <PiArrowFatLinesLeftFill className='text-slate-300/60' size={40} style={{ display: "inline-block" }} />}
        <NavLink to={"/orders"} className='min-h-[150px] flex flex-col items-center justify-center border-0 bg-primary-color rounded-xl shadow-lg py-2 px-5 text-white'>
          <h2 className='text-2xl font-medium'>5</h2> {tHome["trackCustTxt"]}</NavLink>
      </div>
      {!auth.role?.includes("VENDOR_USER") &&
        <div className="flex justify-between my-6">
          <div className="flex flex-col w-[30%] p-4 rounded-2xl shadow-2 bg-gray-50 border border-gray-100">
            {state.isLoading && !details
              ? <AppLoading />
              : <div>
                <div className="flex justify-between items-center">
                  <h3 className='font-medium'>{tHome["earningTxt"]}</h3>
                  <DollarCircle variant="Bulk" className='text-green-300' size={45} />
                </div>
                <h2 className='font-semibold mt-3'>{details?.earnings} {t("aedUnit")}</h2>
                <p>{tHome["revenueTxt"]}</p>
              </div>}
          </div>

          <div className="flex flex-col w-[30%] p-4 rounded-2xl shadow-2 bg-gray-50 border border-gray-100">
            {state.isLoading && !details
              ? <AppLoading />
              : <div>

                <div className="flex justify-between items-center">
                  <h3 className='font-medium'>{tHome["orderTxt"]}</h3>
                  <ShoppingCart variant="Bulk" className='bg-amber-200 text-white p-1.5 rounded-full' size={40} />
                </div>
                <h2 className='font-semibold mt-3'>{details?.numberOfOrders}</h2>
                {details?.pendingOrders?.list?.length > 0 ? <p>
                  {tHome["seeTxt"]}
                  <strong className='rounded-full bg-info-200 text-lg px-2 mx-2'>
                    {details?.pendingOrders?.list?.length}
                  </strong>
                  {tHome["pendingTxt"]}</p> : <p>{tHome["noPendingTxt"]}</p>}
              </div>}
          </div>

          <div className="flex flex-col w-[30%] p-4 rounded-2xl shadow-2 bg-gray-50 border border-gray-100">
            {state.isLoading && !details
              ? <AppLoading />
              : <div>
                <div className="flex justify-between items-center">
                  <h3 className='font-medium'>{tHome["productTxt"]}</h3>
                  <Box variant="Bulk"
                    className='bg-blue-200 text-white p-1.5 rounded-full' size={40} />
                </div>
                <h2 className='font-semibold mt-3'>{details?.numberOfProducts}</h2>
              </div>}
          </div>
        </div>}
      <VendorRecentOrdersTable className="my-6" state={state} orders={state?.data?.data?.details?.pendingOrders?.list} title={tHome["pendingTxt"]} />
      <FrequentProductsTable className="my-6" state={state} title={tHome["freqProdTxt"]} labels={tHome} />
    </div>
  )
}

export default VendorHome